import '../index.css'

export default function Terms() {
    return (
        <div className="terms-of-use--container">
            <h1>Terms and Conditions</h1>
            <p>Last updated: September 07, 2023</p>
            <p>Please read these terms and conditions carefully before using Our Service.</p>
            <div className="text-block">
                <div className="ordered-list">
                    <ul className="ordered-list--list">
                        <li>
                            <div>
                                These Terms of Use contain an electronic agreement between you (hereinafter the “User”)
                                and Cold-Wallet and its affiliates (hereinafter the “Cold-Wallet”) regulating the
                                terms and conditions of the User's use of this website and all services, products and
                                content provided by Cold-Wallet.
                            </div>
                        </li>
                        <li>
                            <div>
                                These Terms of Use contain important provisions, which the User must consider carefully
                                and understand when choosing whether to visit the Site and use the services, products
                                and content of Cold-Wallet. Please read these Terms of Use carefully before agreeing to
                                them.
                            </div>
                        </li>
                        <li>
                            <div>
                                References in these Terms of Use to 'Cold-Wallet', 'we', 'our' or 'us', are to the
                                Cold-Wallet, including but not limited to, its employees, directors, officers,
                                agents or other related parties, third parties, whose content is offered on this website
                                and/or in Cold-Wallet Software, depending on the context, and references to “User”,
                                'you' or 'your' are to the person with whom Cold-Wallet enters into the electronic
                                agreement, unless otherwise provided herein.
                            </div>
                        </li>
                        <li>
                            <div>
                                The User is solely responsible for understanding and complying with any and all laws,
                                rules and regulations of his/her specific jurisdiction that may be applicable to the
                                User in connection with the use of any and all services, products and content of
                                Cold-Wallet.
                            </div>
                        </li>
                        <li>
                            <div>
                                By using website of Cold-Wallet or any of our associated websites,
                                APIs, or mobile applications(collectively the 'Cold-Wallet Software') and/or by using
                                Cold-Wallet Software, you agree that you have read, understood, and accept all of the
                                terms and conditions contained in these Terms of Use, as well as our Privacy Policy and
                                our anti money laundering policies and procedures. The User has to read and to
                                understand the entire Terms of Use carefully before each using the Site and/or any of
                                the Services provided by Cold-Wallet.
                            </div>
                        </li>
                        <li>
                            <div>
                                IF THE USER DOES NOT ACCEPT AND/OR UNDERSTANDS THESE TERMS OF USE, THE USER SHALL NOT
                                ACCESS THIS SITE AND SHALL NOT USE ANY OF Cold-Wallet SOFTWARE, SERVICES, PRODUCTS AND
                                CONTENT.
                            </div>
                        </li>
                        <li>
                            <div>
                                You should be aware that the risk of loss in trading or holding Digital Currencies can
                                be high. Digital currency services are not currently regulated in most countries (by
                                financial authorities or any other regulator). You should therefore carefully consider
                                whether trading or holding Digital currencies is suitable for you in light of your
                                financial condition and possible risks.
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <div className="text-block">
                <h3>
                    II. DEFINITIONS
                </h3>
                <div className="mb-20">
                    <p>
                        Terms used in these Terms of Use shall be interpreted in accordance with the definitions
                        provided below:<br/>
                        Wallet: anonymous account created by the User on the Platform and/or on the Cold-Wallet
                        Software.
                        <br/>
                        Affiliate: means a legal entity and/or individual which has legal relations with Cold-Wallet
                        being its partner/provider.<br/>
                        Cryptocurrency: means peer-to-peer decentralized digital representation of value (bitcoins,
                        ethers, etc.).<br/>
                        Fiat currency: means government-issued currency, which is regulated in its country of issuance
                        through government regulation or law.<br/>
                        Platform: means an appropriate environment (including software) created by Cold-Wallet<br/>
                        Services: means all and any service provided by Cold-Wallet.<br/>
                        Website or Site: means Cold-Wallet website at https://cold-wallet.app address.<br/>
                        User: means a person or an entity that uses the Services, agrees to follow the Terms of Use and
                        is a holder of a Wallet.<br/>
                        Third-Party Services: among any other services, this includes any bank and/or cryptocurrency
                        exchange platform that our Service is able to fetch the Users' data from.<br/>
                        Access Data: public and secret API-keys, pass-phrases, account and sub-account names, tokens,
                        and any other information that User provides us in context of connection to Third-Party Service.
                        <br/>
                        Received Information: any information that is received from Third-Party Services using User's
                        Access Data<br/>
                        External Wallet: means a Cryptocurrency or Fiat wallet that is not part of the Cold-Wallet
                        platform (Cold-Wallet software) but which can be indicated on the Cold-Wallet platform
                        (Cold-Wallet software).<br/>
                        Where the context so admits words denoting the singular shall include the plural and vice versa.
                    </p>
                </div>
            </div>
            <div className="text-block">
                <h3>
                    III. OUR SERVICES
                </h3>
                <div className="ordered-list">
                    <ul className="ordered-list--list">
                        <li>
                            <div>
                                The Services allow all Users of the Platform (with limitations mentioned in these Terms
                                of Use) to Trade Cryptocurrencies with other Users.
                            </div>
                        </li>
                        <li>
                            <div>
                                Depending on the User's place of residence (and/or other legal facts), the User may not
                                be able to use all the functions of the Site. It is the User's responsibility to follow
                                those rules and laws in his/her place of residence and/or place from which the User
                                accesses this Site. The User must understand that technical possibility to use the
                                appropriate Services on the Platform (Cold-Wallet Software) doesn't mean that such the
                                using is legal for him/her. The User is solely responsible for understanding and
                                complying with any and all laws, rules and regulations of his/her specific jurisdiction
                                that may be applicable to the User in connection with the use of any and all services,
                                products and content of Cold-Wallet.
                            </div>
                        </li>
                        <li>
                            <div>
                                The User acknowledges and agrees that, after providing us Access Data to Third-Party
                                Services, our Service is able and will fetch Received Information.
                                However, our Service will encrypt and store both Access Data and Received Information on
                                User's device, specifically in local and session storage of used web-browser, and will
                                not send Access Data nor Received Information to our servers. Received Information will
                                never be sent anywhere.
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <div className="text-block">
                <h3>
                    IV. OUR RIGHTS, RESPONSIBILITIES AND WARRANTIES
                </h3>
                <div className="ordered-list">
                    <ul className="ordered-list--list">
                        <li>
                            <div>
                                Cold-Wallet undertakes to provide the Services with the appropriate effort, due care
                                and in accordance with these Terms of Use. Cold-Wallet's responsibility shall be limited
                                to using reasonable technical efforts to ensure User can see Received Information.
                            </div>
                        </li>
                        <li>
                            <div>
                                To the extent permitted by law, Cold-Wallet is not responsible for any damages, loss of
                                profit, loss of revenue, loss of business, loss of opportunity, loss of data, indirect
                                or consequential loss event.
                            </div>
                        </li>
                        <li>
                            <div>
                                Cold-Wallet is not responsible:
                                — for the delay in the processing of payments made by the fault of any Third-Party
                                Service.
                                — for any malfunction, breakdown, delay or interruption of the Internet connection or
                                any reason why our site is unavailable at any given time.
                            </div>
                        </li>
                        <li>
                            <div>
                                Cold-Wallet is not able to report any requested information to the relevant authorities
                                dealing with fraud and breaches of the law, because Cold-Wallet does not store any data
                                on it's servers.
                            </div>
                        </li>
                        <li>
                            <div>
                                Cold-Wallet does not provide any financial, investment or legal advice in connection
                                with the Services provided by Cold-Wallet. Cold-Wallet may provide information on the
                                price of Cryptocurrencies or Fiat currencies, but it should not be considered as an
                                investment or financial advice and should not be construed as such.
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <div className="text-block">
                <h3>
                    V. THE USER'S RIGHTS, RESPONSIBILITIES AND WARRANTIES
                </h3>
                <div className="ordered-list">
                    <ul className="ordered-list--list">
                        <li>
                            <div>
                                The User has the right to enter and/or use the Site and the Services, as long as he/she
                                agrees to and actually complies with the Terms of Use. By using the Site, the User
                                agrees to accept and comply with the terms and conditions stated herein.
                            </div>
                        </li>
                        <li>
                            <div>
                                The User has to comply with any and all applicable laws and regulations related to the
                                use of the Services.
                            </div>
                        </li>
                        <li>
                            <div>
                                The User warrants to provide us read-only Access Data, e.g. the option "read-only"
                                enabled, disabled "trading operations" and/or "withdrawal operations" on Third-Party
                                Services platforms' API keys management page.
                            </div>
                        </li>
                        <li>
                            <div>
                                The User represents and warrants that he/she is informed that Cold-Wallet's interactions
                                with Third-Party Services are read-only, and that Cold-Wallet is not able and will not
                                do any other action with User's funds within Third-Party Services except receiving
                                information through the Third-Party Services API.
                            </div>
                        </li>
                        <li>
                            <div>
                                In case of any loss, User warrants that he/she does not have any claims to Cold-Wallet
                                and/or to Affiliates.
                            </div>
                        </li>
                        <li>
                            <div>
                                The User undertakes not to use the Service to perform criminal and/or not legal
                                activity of any sort, including but not limited to, money laundering, illegal gambling
                                operations, financing terrorist organizations, or malicious hacking.
                            </div>
                        </li>
                        <li>
                            <div>
                                The User is responsible for any and all damages caused, and all liability actions
                                brought against Cold-Wallet for infringement of any third-party rights or violation of
                                any applicable laws. Nothing in the Terms of Use excludes or limits the liability of the
                                User for fraud, penalties any other negative consequences, caused by their negligence,
                                breach of the terms implied by operation of law or any other liability which may not be
                                limited or excluded by law.
                            </div>
                        </li>
                        <li>
                            <div>
                                All added Access Data to your Wallet of any Third-Party Service must be personalized and
                                owned by the Wallet holder. Any attempt otherwise will (or can) be recognized as fraud.
                            </div>
                        </li>
                        <li>
                            <div>
                                By creating a Wallet, the User expressly represents and warrants that he/she:
                                follows the rules and laws in his/her country of residence and/or country from which
                                he/she accesses this Site and Services; has accepted these Terms of Use; is at least 18
                                years old and has the right to accept these Terms of Use.
                            </div>
                        </li>
                        <li>
                            <div>
                                The User represents and warrants that he/she will only use the Platform in accordance
                                with the conditions set forth in these Terms and that they are duly authorized and have
                                the capacity to enter into the Wallet on the Platform.
                            </div>
                        </li>
                        <li>
                            <div>
                                The User represents and warrants that all Access Data provided to us belong to the User
                                and derived legally from Third-Party Services without violation of any policies or
                                rights or applicable laws.
                            </div>
                        </li>
                        <li>
                            <div>
                                The User undertakes to pay all his/her taxes and duties, which can be resulted from the
                                use of Cold-Wallet Services and should be paid according to the User's state of
                                residence regulations. Cold-Wallet is not responsible for any violation made by the User
                                due to his/her obligation to calculate and pay taxes and duties.
                            </div>
                        </li>
                        <li>
                            <div>
                                Moreover the User guarantees:<br/>
                                • not to use any deep linking, robots, bots, web crawlers, scrapers, spiders or other
                                automated tools or any similar or equivalent manual tools that have not been provided by
                                Cold-Wallet to access the services or to extract data;<br/>
                                • not to use the services and the Platform bypassing the procedure provided for by these
                                Terms of Use, or bypassing/exceeding the level of the User's access to the Platform; to
                                attempt to access any area of the services, website or Platform to which the User is not
                                authorized to access.
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <div className="text-block">
                <h3>
                    VI. INTELLECTUAL PROPERTY RIGHTS
                </h3>
                <div className="ordered-list">
                    <ul className="ordered-list--list">
                        <li>
                            <div>
                                All content on this Site is the property of Cold-Wallet and is protected by copyright,
                                patent, Trademark and any other applicable laws, unless otherwise specified hereby.
                            </div>
                        </li>
                        <li>
                            <div>
                                The Trademarks, Trade names, service marks and logos of Cold-Wallet and others used on
                                the Site (hereinafter the “Trademarks”) are the property of Cold-Wallet. The software,
                                applications, text, images, graphics, data, prices, charts, graphs, video and
                                audio materials used on this Site belong to Cold-Wallet. The Trademarks and other
                                content on the Site may not be copied, reproduced, modified, republished, uploaded,
                                posted, transmitted, scraped, collected or distributed in any form or by any means, no
                                matter manual or automated. The use of any content from the Site on any other site or a
                                networked computer environment for any other purpose is strictly prohibited; any such
                                unauthorized use may violate copyright, patent, Trademark and any other applicable laws
                                and could result in criminal or civil penalties.
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <div className="text-block">
                <h3>
                    VIII. ACCOUNT MAINTENANCE
                </h3>
                <div className="ordered-list">
                    <ul className="ordered-list--list">
                        <li>
                            <div>
                                The Site is for the User's personal and non-commercial use only. Cold-Wallet is
                                vigilant in maintaining the security of the Site and the Service.
                            </div>
                        </li>
                        <li>
                            <div>
                                The User agrees that he/she will not use any Access Data other than their own or access
                                the Wallet of any other User at any time, or assist others in obtaining unauthorized
                                access.
                            </div>
                        </li>
                        <li>
                            <div>
                                The User is responsible for maintaining the confidentiality of information on their
                                Wallet, including, but not limited to their Access Data. The User is obligated to comply
                                with these security requests or accept termination of their Wallet.
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <div className="text-block">
                <h3>
                    XII. ACCOUNT SECURITY
                </h3>
                <div className="ordered-list">
                    <ul className="ordered-list--list">
                        <li>
                            <div>
                                The User is responsible for maintaining the confidentiality of their Wallet's
                                credentials, including, but not limited to a password, pin-code, any other data related
                                to the Wallet, including Access Data.
                            </div>
                        </li>
                        <li>
                            <div>
                                Cold-Wallet personnel will never ask the User to disclose their pin-code or Access Data.
                                Any message the User receives or website that he/she visits that asks for credentials,
                                other than the Cold-Wallet Site, should be reported to Cold-Wallet. Before each using of
                                the Website the User has to check (ensure) that he/she is using a genuine website.
                            </div>
                        </li>
                        <li>
                            <div>
                                We advise to change the User's credentials regularly in order to reduce the risk of a
                                security breach in relation to the Wallet. The User must never allow anyone to access
                                his/her Wallet or watch the User accessing his/her Wallet. If the User has any
                                security concerns concerning his/her Wallet, login details, (password or other security
                                feature being lost, stolen, misappropriated, used without authorization or otherwise
                                compromised), the User is advised to change credentials immediately. The User must
                                contact support service without undue delay on becoming aware of any loss, theft,
                                misappropriation or unauthorized use of the Wallet, login details, password or other
                                security features. Any undue delay in notifying Cold-Wallet may not only affect the
                                security of the Wallet but may result in the User being liable for any losses as a
                                result. If the User suspects that someone else accessed his/her Wallet, the User should
                                also contact an appropriate government agency and report the incident.
                            </div>
                        </li>
                        <li>
                            <div>
                                Irrespective of whether the User is using a public, a shared or his/her own computer to
                                access the Wallet, the User must be aware that his/her login details are stored
                                encrypted in the browser's local and session storage.
                            </div>
                        </li>
                        <li>
                            <div>We strictly recommend to use additional authentication options of the Platform.</div>
                        </li>
                    </ul>
                </div>
            </div>
            <div className="text-block">
                <h3>
                    XIII. TERMINATION OF THE TERMS OF USE
                </h3>
                <div className="ordered-list">
                    <ul className="ordered-list--list">
                        <li>
                            <div>
                                In order to terminate Terms of Use, the User may delete it's Wallet data from browser's
                                local storage.
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <div className="text-block">
                <h3>
                    XIV. SERVICES AVAILABILITY
                </h3>
                <div className="ordered-list">
                    <ul className="ordered-list--list">
                        <li>
                            <div>
                                All Services are provided “AS IS”, without guarantees of any kind, either expressed or
                                implied.
                            </div>
                        </li>
                        <li>
                            <div>
                                Cold-Wallet will strive to keep the Site up and running; however, all online services
                                suffer from occasional disruptions and outages and Cold-Wallet is not liable for any
                                disruption or loss the User may suffer as a result.
                            </div>
                        </li>
                        <li>
                            <div>
                                Thus, Cold-Wallet does not provide any guarantees that access to the Site will not be
                                interrupted or that there will be no delays, failures, errors, omissions or loss of
                                transmitted information.
                            </div>
                        </li>
                        <li>
                            <div>
                                Cold-Wallet will use reasonable efforts to ensure that the User can normally access the
                                Site in accordance with the Terms of Use. Cold-Wallet may suspend use of the Site for
                                maintenance and will make reasonable efforts to give the User a notice. The User
                                acknowledges that this may not be possible in an emergency.
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <div className="text-block">
                <h3>
                    XVI. WIDGETS AND MOBILE APPLICATIONS
                </h3>
                <div className="ordered-list">
                    <ul className="ordered-list--list">
                        <li>
                            <div>
                                Cold-Wallet may provide widgets for the User's use to put our data on the User's Site.
                                The User is free to use widgets in their original unmodified and unaltered state.
                            </div>
                        </li>
                        <li>
                            <div>
                                Cold-Wallet may provide mobile applications (“mobile apps”), which can be used to get
                                an access to the Wallet. The use of these mobile apps is the subject to these Terms of
                                Use.
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <div className="text-block">
                <h3>
                    XVII. NOTICES AND COMMUNICATION
                </h3>
                <div className="ordered-list">
                    <ul className="ordered-list--list">
                        <li>
                            <div>
                                The official information channel of Cold-Wallet is the Website. The Website may contain
                                a links to other official information channels of Cold-Wallet. Nevertheless any
                                recommendation and/or Trade idea (even on official channel of Cold-Wallet) don't have a
                                status of official recommendation and/or Trade idea of Cold-Wallet.
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <div className="text-block">
                <h3>
                    XIX. GOVERNING LAW AND DISPUTE RESOLUTION
                </h3>
                <div className="ordered-list">
                    <ul className="ordered-list--list">
                        <li>
                            <div>
                                These Terms of Use shall be governed by and construed in accordance with the laws of
                                Ukraine, unless otherwise expressly provided.
                            </div>
                        </li>
                        <li>
                            <div>
                                All disputes arising out of or in connection with the present contract shall be finally
                                settled by arbitration in accordance with the Rules of the Arbitration Court of the
                                Ukrainian Chamber of Commerce and Industry. The Parties shall attempt to resolve all
                                disputes relating to these Terms of Use by negotiations. If the Parties fail to resolve
                                the disputes relating to these Terms of Use through negotiations, the dispute shall be
                                conclusively resolved in the Arbitration Court of the Chamber of Commerce and Industry
                                of Ukraine in Kyiv (hereinafter: the Arbitration Court) in accordance with the Rules of
                                the Arbitration Court. The dispute shall be resolved on the basis of the laws of
                                Ukraine. The language of the Arbitration Court shall be Ukrainian. The Arbitration Court
                                shall consist of 3 (three) members. Each Party shall appoint one arbitrator within the
                                time period prescribed by the Council of the Arbitration Court of the Chamber of
                                Commerce and Industry of Ukraine. Each Party shall ask the arbitrator chosen by him to
                                appoint a third arbitrator together with the arbitrator chosen by the other Party, who
                                shall be the chairman of the Arbitration Court in the resolution of the dispute. If the
                                arbitrators appointed by the Parties fail to choose a third arbitrator within the time
                                period prescribed by the Council of the Arbitration Court of the Chamber of Commerce and
                                Industry of Ukraine, the third arbitrator who shall also be the chairman of the
                                Arbitration Court shall be appointed by the Council of the Arbitration Court of the
                                Chamber of Commerce and Industry. If the Parties fail to form the Arbitration Court in
                                accordance with the provisions of these Terms of Use and the Rules of the Arbitration
                                Court, the Arbitration Court shall be formed by the Council of the Chamber of Commerce
                                and Industry of Ukraine. The award of the Arbitration Court shall be final and binding
                                upon the Parties.
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <div className="text-block">
                <h3>
                    XX. LIMITATION OF LIABILITY
                </h3>
                <div className="mb-20">
                    <p>
                        IN NO EVENT SHALL Cold-Wallet, ITS OFFICERS, DIRECTORS, EMPLOYEES, AGENTS, AND ALL THIRD PARTY
                        SERVICE PROVIDERS BE LIABLE TO THE USER OR ANY OTHER PERSON OR ENTITY FOR ANY DIRECT, INDIRECT,
                        INCIDENTAL, SPECIAL, PUNITIVE OR CONSEQUENTIAL DAMAGES WHATSOEVER, INCLUDING ANY THAT MAY RESULT
                        FROM (I) ACCURACY, COMPLETENESS OR CONTENT OF THIS SITE, (II) ACCURACY, COMPLETENESS OR CONTENT
                        OF ANY SITES LINKED (THROUGH HYPERLINKS, BANNER ADVERTISING OR OTHERWISE) TO THIS SITE, (III)
                        THE SERVICES FOUND AT THIS SITE OR ANY SITES LINKED (THROUGH HYPERLINKS, BANNER ADVERTISING OR
                        OTHERWISE) TO THIS SITE, (IV) PERSONAL INJURY OR PROPERTY DAMAGE OF ANY NATURE WHATSOEVER, (V)
                        THIRD-PARTY CONDUCT OF ANY NATURE WHATSOEVER, (VI) ANY UNAUTHORIZED ACCESS TO OR USE OF OUR
                        SERVICES AND/OR ANY AND ALL CONTENT, PERSONAL INFORMATION, FINANCIAL INFORMATION OR OTHER
                        INFORMATION AND DATA STORED THEREIN, (VII) ANY INTERRUPTION OR CESSATION OF SERVICES TO OR FROM
                        THIS SITE OR ANY SITES LINKED (THROUGH HYPERLINKS, BANNER ADVERTISING OR OTHERWISE) TO THIS
                        SITE, (VIII) ANY VIRUSES, WORMS, BUGS, TROJAN HORSES OR THE LIKE, WHICH MAY BE TRANSMITTED TO OR
                        FROM THIS SITE OR ANY SITES LINKED (THROUGH HYPERLINKS, BANNER ADVERTISING OR OTHERWISE) TO THIS
                        SITE, (IX) ANY USER CONTENT OR CONTENT THAT IS DEFAMATORY, HARASSING, ABUSIVE, HARMFUL TO MINORS
                        OR ANY PROTECTED CLASS, PORNOGRAPHIC, “X-RATED”, OBSCENE OR OTHERWISE OBJECTIONABLE AND/ OR (X)
                        ANY LOSS OR DAMAGE OF ANY KIND INCURRED AS A RESULT OF THE USER'S USE OF THIS SITE OR THE
                        SERVICES FOUND AT THIS SITE, WHETHER BASED ON WARRANTY, CONTRACT, TORT OR ANY OTHER LEGAL OR
                        EQUITABLE THEORY AND WHETHER OR NOT Cold-Wallet IS ADVISED OF THE POSSIBILITY OF SUCH DAMAGES.
                        IN ADDITION, YOU SPECIFICALLY ACKNOWLEDGE AND AGREE THAT ANY CAUSE OF ACTION ARISING OUT OF OR
                        RELATED TO THIS SITE OR THE SERVICES FOUND AT THIS SITE MUST BE COMMENCED WITHIN ONE (1) YEAR
                        AFTER THE CAUSE OF ACTION ACCRUES, OTHERWISE SUCH CAUSE OF ACTION SHALL BE PERMANENTLY BARRED.
                        IN ADDITION, THE USER SPECIFICALLY ACKNOWLEDGE AND AGREE THAT IN NO EVENT SHALL Cold-Wallet'S
                        TOTAL AGGREGATE LIABILITY EXCEED THE TOTAL AMOUNT PAID BY THE USER FOR THE PARTICULAR SERVICES
                        THAT ARE THE SUBJECT OF THE CAUSE OF ACTION. THE FOREGOING LIMITATION OF LIABILITY SHALL APPLY
                        TO THE FULLEST EXTENT PERMITTED BY LAW AND SHALL SURVIVE ANY TERMINATION OR EXPIRATION OF THESE
                        TERMS OF USE OR THE USER'S USE OF THIS SITE OR THE SERVICES FOUND AT THIS SITE.
                    </p>
                </div>
            </div>
            <div className="text-block">
                <h3>
                    XXI. INDEMNITY
                </h3>
                <div className="mb-20">
                    <p>
                        The User agrees to protect, defend, indemnify and hold harmless Cold-Wallet and its officers,
                        directors, employees, agents and third party service providers from and against any and all
                        claims, demands, costs, expenses, losses, liabilities and damages of every kind and nature
                        (including, without limitation, reasonable attorneys' fees) imposed upon or incurred by
                        Cold-Wallet directly or indirectly arising from (i) the User's use of and access to this Site or
                        the Services found at this Site; (ii) the User's violation of any provision of the Terms of Use
                        or the policies or agreements which are incorporated herein; and/or (iii) the User's violation
                        of any third-party right, including without limitation any intellectual property or other
                        proprietary right. The indemnification obligations under this section shall survive any
                        termination or expiration of the Terms of Use or the User's use of this Site or the Services
                        found on this Site.
                    </p>
                </div>
            </div>
            <div className="text-block">
                <h3>
                    XXII. MODIFICATIONS AND AMENDMENTS
                </h3>
                <div className="ordered-list">
                    <ul className="ordered-list--list">
                        <li>
                            <div>
                                Cold-Wallet reserves the right to amend or modify any portion of these Terms of Use at
                                any time by publishing the revised version of the Terms of Use on the Site. The changes
                                will become effective and shall be deemed accepted by the User, the first time the User
                                uses the Services after the publishing of the revised Terms of Use and shall apply on a
                                going-forward basis with respect to any activity initiated after publishing. In the
                                event that the User does not agree with any such modification, the User's sole and
                                exclusive remedy is to terminate the use of the Services and close the Wallet. The User
                                agrees that Cold-Wallet shall not be liable to the User or any third party as a result
                                of any losses suffered by any modification or amendment of these Terms of Use.
                            </div>
                        </li>
                        <li>
                            <div>
                                If any part of these Terms of Use is held invalid, such invalidity will not invalidate
                                the other provisions of these Terms of Use.
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <div className="text-block">
                <h3>
                    XXIII. FORCE MAJEURE
                </h3>
                <div className="mb-20">
                    <p>
                        If Cold-Wallet is unable to perform the Services outlined in the Terms of Use due to the factors
                        beyond its control including but not limited to the event of Force Majeure, change of law or
                        change in sanctions policy, Cold-Wallet will not have any responsibility to the User with
                        respect to the Services provided hereunder and for a time period coincident with the event.
                    </p>
                </div>
            </div>
            <div className="text-block">
                <h3>
                    XXIV. LINKS TO THIRD-PARTY WEBSITES
                </h3>
                <div className="mb-20">
                    <p>
                        This Site and the Services found at this Site may contain links to third-party websites that are
                        not owned or controlled by Cold-Wallet. Cold-Wallet assumes no responsibility for the content,
                        terms and conditions, privacy policies or practices of any third-party websites. In addition,
                        Cold-Wallet does not censor or edit the content of any third-party websites. By using this Site
                        or the Services found at this Site, you expressly release Cold-Wallet from any and all liability
                        arising from the User's use of any third-party website. Accordingly, Cold-Wallet encourages the
                        User to be aware when the User leaves this Site, or the Services found at this Site and to
                        review the terms and conditions, privacy policies and other governing documents of any other
                        website that you may visit.
                    </p>
                </div>
            </div>
            <div className="text-block">
                <h3>
                    CONTACT US
                </h3>
                <div className="mb-20">
                    <p>
                        If you have any questions relating to these Terms of Use, your rights and obligations arising
                        from these Terms and/or your use of the Site and the Service, your Wallet or any other matter,
                        please, contact us:
                        <address>Email: <a href="mailto:cold.wallet.app@gmail.com">cold.wallet.app@gmail.com</a>
                        </address>
                    </p>
                </div>
            </div>
        </div>
    )
}